import {Navigate} from 'react-router-dom';
import {useSites} from '@/hooks/useSites';

export function RequireOwner({children}: {children: React.ReactNode}) {
    const {data: sites, isLoading} = useSites();

    if (isLoading) {
        return <div className="flex min-h-screen items-center justify-center">Loading…</div>;
    }

    if (!sites?.some(site => site.access_type === 'owner')) {
        return <Navigate to="/dashboard" replace />;
    }

    return <>{children}</>;
}
